import dompurify from 'dompurify';
import { videoUrlsRegex } from 'lib/video-urls';

export const validateIFrame = proposedVideo =>
  new Promise((resolve, reject) => {
    const sanitized = dompurify.sanitize(proposedVideo, {
      ALLOWED_TAGS: ['p', 'a'],
      ADD_TAGS: ['iframe'],
      ADD_URI_SAFE_ATTR: [
        'frameborder',
        'allow',
        'allowfullscreen',
        'allowtransparency',
        'width',
        'height',
        'referrerpolicy',
        'scrolling',
        'style',
        'title'
      ],
      ADD_ATTR: [
        'frameborder',
        'allow',
        'allowfullscreen',
        'allowtransparency',
        'href',
        'referrerpolicy',
        'scrolling',
        'src',
        'style',
        'title'
      ],
      ALLOWED_URI_REGEXP: videoUrlsRegex,
      ALLOW_DATA_ATTR: false,
    });

    if (sanitized && sanitized.includes('iframe') && dompurify.removed.length === 1) {
      resolve(sanitized);
    } else {
      reject();
    }
  });
